import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'
import { getContentfulImageURL } from '../../lib/helpers'

const Meta = (props) => {
  const {
    activeTitle,
    description,
    lang,
    image,
    tags,
    meta,
    title,
    author,
  } = props
  const query = useStaticQuery(
    graphql`
    query MetaQuery {
      allContentfulSiteGlobalData(filter: { node_locale: { eq: "en-US" } }) {
        edges {
          node {
            defaultSeoImage {
              file {
                url
              }
            }
          }
        }
      }
  
    }
    `
  )


  const headDescription = description || "Welcome to Bloom Season, a resource and community made for and by historically-excluded entrepreneurs to help rewrite the blueprint for small business success. Each edition contains firsthand experience, practical advice, and actionable resources developed specifically for these business owners."
  const headImage = image ? `https:${getContentfulImageURL(image.file, 600, 90, "png")}` : `https:${getContentfulImageURL(query?.allContentfulSiteGlobalData?.edges[0]?.node?.defaultSeoImage?.file, 600, 90, "png")}`;
  const headTitle = !title ? 'Bloom Season' : `Bloom Season | ${title}`;

  // console.log(headImage)
  return (
    <>
    
      <Helmet
	  htmlAttributes={{
	  	lang: 'en',
      }}>
          <meta charSet="utf-8" />
          <title>{headTitle}</title>

          <meta name="description" content={headDescription} />
          <meta name="image" content={headImage}/>

          <meta itemprop="name" content={headTitle}/>
          <meta itemprop="description" content={headDescription}/>
          <meta itemprop="image" content={headImage}/>

	        <meta property="og:title" content={headTitle}/>
	        <meta property="og:site_name" content="Bloom Season"/>
	        <meta property="og:description" content={headDescription} />
	        <meta property="og:type" content="website"/>
	        <meta property="og:image:url" content={headImage}/>

	        <meta name="twitter:card" content="summary"/>
	        <meta name="twitter:title" content={headTitle}/>
	        <meta name="twitter:description" content={headDescription}/>
	        <meta name="twitter:image" content={headImage}/>

          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta rel="canonical" href="https://mailchimp.com/bloomseason/" />
          <meta name="google-site-verification" content="Y664MhrAfK0N_79j90JEaobbbA7DsLORjh_B9SjviDA" />
      </Helmet>
    </>
  )
}

Meta.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Meta.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default Meta
